export default "__VITE_ASSET__BrKc$m9v__"